define.alias("shared/components/shared/date-picker", "calendar/components/shared/date-picker");